export interface Comic {
  id: string;
  title: string;
  genre: string;
  status: string;
  chapters: number;
  rating: number;
  tags: string[];
  description: string;
  image: string;
  updated: string;
  year: string;
  author: string;
}

export const comicGenres = [
  { name: "热血", icon: "ri-fire-line" },
  { name: "科幻", icon: "ri-rocket-line" },
  { name: "奇幻", icon: "ri-magic-line" },
  { name: "日常", icon: "ri-cup-line" },
  { name: "悬疑", icon: "ri-spy-line" },
  { name: "冒险", icon: "ri-compass-line" },
];

export const comics: Comic[] = [
  {
    id: "xingchen-yongzhe",
    title: "星辰勇者录",
    genre: "热血",
    status: "连载中",
    chapters: 268,
    rating: 9.4,
    tags: ["冒险", "成长", "热血"],
    description:
      "背负星之纹章的少年踏上寻回失落星辉的征途，在一路与强大敌人的交锋中逐渐揭开世界的真相。热血与羁绊交织的长篇史诗，持续更新近五年，热度始终高居榜首。",
    image: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20comic%20book%20cover%20art%20of%20a%20young%20hero%20warrior%20wielding%20a%20glowing%20sword%20against%20a%20starry%20night%20sky%2C%20bold%20dynamic%20composition%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20stylized%20energetic%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-xingchen-01&orientation=portrait",
    updated: "今日更新",
    year: "2021",
    author: "暮星工作室",
  },
  {
    id: "lingxi-jishi",
    title: "零系记事簿",
    genre: "日常",
    status: "连载中",
    chapters: 156,
    rating: 9.1,
    tags: ["治愈", "校园", "日常"],
    description:
      "转学生在新城市的一本神奇记事簿里，写下的每个故事都会悄然发生。温柔治愈的单元剧长篇，细腻刻画平凡生活中的闪光瞬间，陪伴无数读者度过每个深夜。",
    image: "https://readdy.ai/api/search-image?query=soft%20warm%20anime%20manga%20comic%20cover%20art%20of%20a%20teenage%20student%20with%20a%20magical%20notebook%20and%20floating%20sparkles%2C%20cozy%20comfortable%20feel%2C%20cream%20and%20golden%20tones%2C%20gentle%20clean%20illustration%2C%20peaceful%20atmosphere%2C%20high%20detail&width=600&height=850&seq=comic-lingxi-02&orientation=portrait",
    updated: "昨日更新",
    year: "2020",
    author: "纸间拾光",
  },
  {
    id: "jixie-chengbao",
    title: "机械城堡",
    genre: "科幻",
    status: "连载中",
    chapters: 322,
    rating: 9.6,
    tags: ["科幻", "机甲", "战斗"],
    description:
      "被改造成机械义体的少年在钢铁城市中崛起，一步步揭露机械城堡背后的惊世阴谋。硬核机甲战斗与深刻人性探讨并重，更新稳定节奏扎实，是科幻迷的必追之作。",
    image: "https://readdy.ai/api/search-image?query=dramatic%20anime%20manga%20comic%20cover%20art%20of%20a%20mecha%20cyborg%20pilot%20inside%20a%20huge%20mechanical%20castle%20city%2C%20metallic%20teal%20and%20coral%20accents%2C%20epic%20scale%2C%20bold%20dynamic%20mecha%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-jixie-03&orientation=portrait",
    updated: "今日更新",
    year: "2019",
    author: "齿轮与火",
  },
  {
    id: "shenyu-chongzou",
    title: "神域重奏",
    genre: "奇幻",
    status: "连载中",
    chapters: 198,
    rating: 9.0,
    tags: ["奇幻", "魔法", "史诗"],
    description:
      "魔法体系崩坏千年后，少女乐师以失落的重奏之力唤醒沉睡的神域。宏大的世界观设定与多线叙事交织，稳定更新数千天，构建出令人神往的魔法大陆。",
    image: "https://readdy.ai/api/search-image?query=fantasy%20anime%20manga%20comic%20cover%20art%20of%20an%20ethereal%20musician%20girl%20conducting%20magical%20golden%20energy%20strings%20in%20a%20ruined%20divine%20temple%2C%20amber%20and%20teal%20palette%2C%20mystical%20detailed%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-shenyu-04&orientation=portrait",
    updated: "今日更新",
    year: "2022",
    author: "弦上月",
  },
  {
    id: "yinying-zhuizong",
    title: "阴影追踪者",
    genre: "悬疑",
    status: "连载中",
    chapters: 142,
    rating: 9.2,
    tags: ["悬疑", "推理", "都市"],
    description:
      "刑侦顾问在一桩桩离奇案件中抽丝剥茧，发现所有线索都指向十年前的一桩悬案。烧脑推理与细腻人物塑造并重，节奏紧凑反转不断，让读者欲罢不能。",
    image: "https://readdy.ai/api/search-image?query=noir%20style%20anime%20manga%20comic%20cover%20art%20of%20a%20detective%20silhouette%20in%20rainy%20city%20alley%20with%20mysterious%20shadows%2C%20dark%20warm%20tones%20with%20coral%20highlight%2C%20suspenseful%20moody%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-yinying-05&orientation=portrait",
    updated: "今日更新",
    year: "2021",
    author: "雾城观澜",
  },
  {
    id: "kuangchao-jiaodui",
    title: "狂潮脚踏车",
    genre: "冒险",
    status: "连载中",
    chapters: 110,
    rating: 8.8,
    tags: ["冒险", "旅行", "喜剧"],
    description:
      "三个性格迥异的伙伴骑着脚踏车环游世界，一路上笑料百出又意外不断。轻松明快的长篇冒险喜剧，持续稳定更新，传递着勇敢出发的浪漫与勇气。",
    image: "https://readdy.ai/api/search-image?query=fun%20colorful%20anime%20manga%20comic%20cover%20art%20of%20three%20friends%20riding%20bicycles%20on%20a%20sunny%20road%20through%20colorful%20landscape%2C%20bright%20warm%20palette%2C%20playful%20energetic%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-kuangchao-06&orientation=portrait",
    updated: "昨日更新",
    year: "2022",
    author: "风铃漫画",
  },
  {
    id: "yuzhou-zhiqiao",
    title: "宇宙之桥",
    genre: "科幻",
    status: "连载中",
    chapters: 236,
    rating: 9.3,
    tags: ["科幻", "太空", "文明"],
    description:
      "人类首次跨入河外星系，在神秘文明留下的「宇宙之桥」前展开一场跨越光年的文明对话。想象力宏大、设定严谨，长期稳定更新的太空史诗。",
    image: "https://readdy.ai/api/search-image?query=breathtaking%20anime%20manga%20comic%20cover%20art%20of%20astronauts%20approaching%20a%20giant%20glowing%20bridge%20in%20deep%20space%20between%20galaxies%2C%20teal%20and%20amber%20neon%20tones%2C%20vast%20cosmic%20scale%2C%20epic%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-yuzhou-07&orientation=portrait",
    updated: "今日更新",
    year: "2018",
    author: "轨道深处",
  },
  {
    id: "wanhua-chudian",
    title: "万花甜品铺",
    genre: "日常",
    status: "连载中",
    chapters: 88,
    rating: 9.0,
    tags: ["治愈", "美食", "日常"],
    description:
      "巷口一家会随四季变化的甜品铺，老板娘用一碗碗甜蜜治愈来往路人的心结。温馨治愈的美食单元剧，稳定更新的甜度满分日常，暖胃更暖心。",
    image: "https://readdy.ai/api/search-image?query=sweet%20anime%20manga%20comic%20cover%20art%20of%20a%20cozy%20dessert%20shop%20counter%20with%20colorful%20cakes%20and%20a%20smiling%20shopkeeper%2C%20warm%20pink%20and%20golden%20palette%2C%20soft%20pastel%20comforting%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-wanhua-08&orientation=portrait",
    updated: "昨日更新",
    year: "2023",
    author: "甜度研究所",
  },
  {
    id: "fengyin-dawang",
    title: "封印的亡灵",
    genre: "悬疑",
    status: "连载中",
    chapters: 174,
    rating: 8.9,
    tags: ["悬疑", "灵异", "都市"],
    description:
      "能在封印里与亡灵对话的少年，在一次次惊悚委托中寻找自己遗忘的记忆。恐怖氛围与温情内核并存，长期更新不断更的都市灵异长篇。",
    image: "https://readdy.ai/api/search-image?query=dark%20moody%20anime%20manga%20comic%20cover%20art%20of%20a%20boy%20facing%20translucent%20ghostly%20figure%20with%20seal%20symbols%2C%20deep%20warm%20shadows%20with%20coral%20glow%2C%20supernatural%20atmospheric%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-fengyin-09&orientation=portrait",
    updated: "今日更新",
    year: "2020",
    author: "夜航星图",
  },
  {
    id: "shiwang-gongju",
    title: "石王公会",
    genre: "热血",
    status: "连载中",
    chapters: 295,
    rating: 9.5,
    tags: ["冒险", "热血", "公会"],
    description:
      "落魄的石头系能力者组建起不被人看好的小公会，却一步步在各大竞技赛中逆袭封王。群像刻画热血沸腾，稳定更新的王道长篇，追更体验极佳。",
    image: "https://readdy.ai/api/search-image?query=epic%20anime%20manga%20comic%20cover%20art%20of%20a%20band%20of%20adventurers%20guild%20standing%20proud%20with%20a%20stone%20monster%20ally%2C%20heroic%20warm%20coral%20and%20golden%20tones%2C%20dynamic%20team%20composition%2C%20high%20detail&width=600&height=850&seq=comic-shiwang-10&orientation=portrait",
    updated: "今日更新",
    year: "2019",
    author: "磐石工作室",
  },
  {
    id: "shizhe-jiyu",
    title: "时之遗迹",
    genre: "奇幻",
    status: "连载中",
    chapters: 121,
    rating: 9.1,
    tags: ["奇幻", "时空", "冒险"],
    description:
      "考古少女误入时间停滞的遗迹，每解开一道机关便回溯一段被遗忘的历史。奇幻设定与解谜元素巧妙结合，持续稳定更新的时空冒险长篇。",
    image: "https://readdy.ai/api/search-image?query=mysterious%20anime%20manga%20comic%20cover%20art%20of%20an%20archaeologist%20girl%20inside%20an%20ancient%20ruined%20temple%20with%20floating%20hourglasses%20and%20crystals%2C%20amber%20and%20teal%20palette%2C%20adventurous%20detailed%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-shizhe-11&orientation=portrait",
    updated: "昨日更新",
    year: "2021",
    author: "刻痕时光",
  },
  {
    id: "haiyang-zhaoqin",
    title: "海洋调音师",
    genre: "冒险",
    status: "连载中",
    chapters: 96,
    rating: 8.7,
    tags: ["海洋", "治愈", "冒险"],
    description:
      "能用旋律与海洋生物沟通的年轻调音师，驾驶改造潜艇巡游七海，治愈被污染的海域。清新治愈与宏大海洋设定并存，稳定更新的蓝色治愈之旅。",
    image: "https://readdy.ai/api/search-image?query=peaceful%20anime%20manga%20comic%20cover%20art%20of%20a%20young%20musician%20with%20submarine%20surrounded%20by%20friendly%20whales%20and%20fish%20in%20clear%20ocean%2C%20teal%20and%20golden%20palette%2C%20soft%20dreamy%20illustration%2C%20high%20detail&width=600&height=850&seq=comic-haiyang-12&orientation=portrait",
    updated: "今日更新",
    year: "2022",
    author: "潮汐社",
  },
];

export const hotRanking = [
  { id: "jixie-chengbao", title: "机械城堡", score: "9.6", heat: "1280w" },
  { id: "shiwang-gongju", title: "石王公会", score: "9.5", heat: "1160w" },
  { id: "xingchen-yongzhe", title: "星辰勇者录", score: "9.4", heat: "1090w" },
  { id: "yuzhou-zhiqiao", title: "宇宙之桥", score: "9.3", heat: "980w" },
  { id: "yinying-zhuizong", title: "阴影追踪者", score: "9.2", heat: "860w" },
  { id: "lingxi-jishi", title: "零系记事簿", score: "9.1", heat: "790w" },
];

export const faqs = [
  {
    question: "天天漫画网的漫画多久更新一次？",
    answer:
      "我们精选的长篇连载漫画均保持稳定更新，绝大多数作品每周固定更新 2–3 次，热门神作甚至做到日更。每部作品的更新频率都会在详情页明确标注，让您追更不迷路。",
  },
  {
    question: "「追更神器」功能如何使用？",
    answer:
      "在漫画详情页点击「加入追更」即可订阅该作品。系统会记录您的追更进度，并在每次更新时及时提醒，让您不会错过任何一话的更新。",
  },
  {
    question: "所有连载漫画都是免费观看的吗？",
    answer:
      "是的，天天漫画网所有长期连载漫画均免费提供在线阅读。我们通过稳定更新与优质内容吸引读者，不设置任何付费阅读门槛。",
  },
  {
    question: "如何找到我喜欢的连载题材？",
    answer:
      "您可以通过「全部连载」页面的分类筛选功能，按热血、科幻、奇幻、日常、悬疑、冒险等题材快速定位心仪的作品，也可以参考首页的更新榜单与热度排行。",
  },
  {
    question: "漫画会突然断更或下架吗？",
    answer:
      "我们与合作工作室保持长期稳定合作，精选作品均承诺持续更新。如遇特殊情况，会在作品页发布公告说明，最大程度保障读者的追更体验。",
  },
];

export const testimonials = [
  {
    name: "阿澈",
    role: "六年资深追更党",
    avatar: "https://readdy.ai/api/search-image?query=cute%20flat%20style%20avatar%20illustration%20of%20a%20young%20man%20with%20orange%20hair%20warm%20background%2C%20simple%20clean%20cartoon%20portrait&width=200&height=200&seq=avatar-01&orientation=squarish",
    text: "在天天漫画网追「机械城堡」快四年了，从来不用担心断更，每天的更新提醒比闹钟还准时，追更焦虑彻底治愈了。",
  },
  {
    name: "小满",
    role: "科幻漫画爱好者",
    avatar: "https://readdy.ai/api/search-image?query=cute%20flat%20style%20avatar%20illustration%20of%20a%20young%20woman%20with%20long%20dark%20hair%20warm%20background%2C%20simple%20clean%20cartoon%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish",
    text: "分类筛选特别好用，科幻和日常都整理得清清楚楚，更新的长篇都很有质量，是真正的追更神器没错了。",
  },
  {
    name: "大熊",
    role: "夜班通勤漫友",
    avatar: "https://readdy.ai/api/search-image?query=cute%20flat%20style%20avatar%20illustration%20of%20a%20young%20man%20with%20brown%20hair%20warm%20background%2C%20simple%20clean%20cartoon%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish",
    text: "上班路上追「星辰勇者录」，排版清爽、加载流畅，稳定更新这点真的深得我心，已经推荐给好几个同事了。",
  },
];